import { useWebSocket } from "@/lib/cjs-interop";
import React from "react";
import { TxType } from "@/types/transaction";

export interface UploadStatusMessage {
  progress: number;
  tx_id: string;
  tx_type: TxType;
  type: "transaction" | "document" | "snapshot";
  fse_ids: string[];
  status: "pending" | "in_progress" | "completed" | "partially_failed" | "failed";
  current_event: string | null;
  error_code: string | null;
}

export const useUploadStatus = (onProgress: (event: UploadStatusMessage) => void) => {
  const { lastJsonMessage } = useWebSocket<UploadStatusMessage>("/pf-mainweb/document/status", {
    share: true,
    skipAssert: true,
    shouldReconnect: event => event?.code !== 1000,
  });

  React.useEffect(() => {
    if (!lastJsonMessage) {
      return;
    }

    onProgress(lastJsonMessage);
  }, [lastJsonMessage, onProgress]);
};
